/**
 * Landing page discount code manager & scroll-to-cart handler.
 *
 * Config is read from a <script type="application/json" data-landing-config>
 * element on the page:
 *   { "discountCode": "MYCODE" }
 *
 * If no config element exists, it still initialises the scroll-to-cart handler.
 */
(function () {
  function getCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  function init() {
    /* ---- Scroll-to-cart ---- */
    var discoverButton = document.querySelector('.js-scroll-to');
    if (discoverButton) {
      discoverButton.addEventListener('click', function (e) {
        e.preventDefault();
        var cartButton = document.querySelector('.js-cta-btn');
        if (cartButton) cartButton.click();
      });
    }

    /* ---- Discount code manager ---- */
    var configEl = document.querySelector('script[data-landing-config]');
    var discountCode = '';
    if (configEl) {
      try {
        var cfg = JSON.parse(configEl.textContent);
        discountCode = (cfg.discountCode || '').trim();
      } catch (e) { /* ignore parse errors */ }
    }

    // Cookie override
    var cookieCode = getCookie('discount_code');
    if (cookieCode) discountCode = cookieCode;
    discountCode = (discountCode || '').trim();

    // Update discount label text
    var labels = document.querySelectorAll('.js-discount-code');
    labels.forEach(function (el) {
      el.textContent = discountCode ? discountCode.toUpperCase() + ' Applied + ' : '';
    });

    // Collect current URL params for passthrough
    var urlParts = window.location.href.split('?');
    var extraParams = urlParts.length > 1 ? urlParts[1] : '';

    // Update checkout/CTA button hrefs
    var buttons = document.querySelectorAll('.js-cta-btn, .js-checkout-btn');
    buttons.forEach(function (btn) {
      var href = btn.getAttribute('href') || '';
      if (!href) return;

      // Append discount code
      if (discountCode && href.indexOf('discount=') === -1) {
        href += (href.indexOf('?') === -1 ? '?' : '&') + 'discount=' + encodeURIComponent(discountCode);
      }

      // Preserve URL params from current page
      if (extraParams) {
        href += (href.indexOf('?') === -1 ? '?' : '&') + extraParams;
      }

      btn.setAttribute('href', href);

      // Force navigation on click (some buttons have default prevented elsewhere)
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.href = href;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
